export class CstCustPhone {
    phoneSeq: string
    custId: string;
    portfolioId: number;
};